export var UNCATEGORIZED = 'uncategorized';
export function getSortedCategories(categories, categoryOrder) {
  // this check is for questions which were created before
  // categoryOrder was introduced
  if (!categoryOrder) {
    // NOTE: Object.values does not guarantee category order
    return Object.values(categories);
  }
  return categoryOrder.map(function (categoryId) {
    return categories[categoryId];
  });
}